import type { RouteRecordRaw, Router } from 'vue-router'

const ExchangeContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/exchange',
  name: 'ExchangeModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ExchangeMainRoute',
      component: () => import('./views/AccordView.vue'),
      meta: {
        title: 'exchange.exchangeContract',
      },
    },
    {
      path: 'create',
      name: 'ExchangeCreateRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'exchange.createExchangeContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accordId',
      name: 'ExchangeEditRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'exchange.editExchangeContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accordId',
      name: 'ViewExchangeRoute',
      component: () => import('./views/SingleAccordView.vue'),
      meta: {
        title: 'exchange.ViewExchange',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(ExchangeContractRoutes)
}
